export const API_URLS = {
  dv: 'https://orion-experience-api-qa.beauty.tech',
  qa: 'https://orion-experience-api-qa.beauty.tech',
  np: 'https://orion-experience-api-np.beauty.tech',
  pd: 'https://orion-experience-api.beauty.tech'
} as const;

export const FIREBASE_CONFIG = {
  dv: {
    firebaseConfig: '{ "apiKey": "AIzaSyAFubaRj4i-m0-A8IRFdqAaWaNmNSdVuc0", "authDomain": "oa-bta-servicesplatform-qa.firebaseapp.com", "projectId": "oa-bta-servicesplatform-qa" }',
    firebaseTenant: 'experience-default-udq2l',
  },
  qa: {
    firebaseConfig: '{ "apiKey": "AIzaSyAFubaRj4i-m0-A8IRFdqAaWaNmNSdVuc0", "authDomain": "oa-bta-servicesplatform-qa.firebaseapp.com", "projectId": "oa-bta-servicesplatform-qa" }',
    firebaseTenant: 'experience-default-udq2l',
  },
  np: {
    firebaseConfig: '{ "apiKey": "AIzaSyDDjefF8eCD8DVyVzOoPEk7RkVmgUaK_Rk", "authDomain": "oa-bta-servicesplatform-np.firebaseapp.com", "projectId": "oa-bta-servicesplatform-np" }',
    firebaseTenant: 'experience-default-du623',
  },
  pd: {
    firebaseConfig: '{ "apiKey": "AIzaSyAxvYZJZCCsPUu4mgyqMgdbRCOjjB3pe-E", "authDomain": "oa-bta-servicesplatform-pd.firebaseapp.com", "projectId": "oa-bta-servicesplatform-pd" }',
    firebaseTenant: 'experience-default-svu07',
  },
} as const;

export const getApiUrl = () => {
  const env = process.env.REACT_APP_ENV || 'dv';
  return API_URLS[env as keyof typeof API_URLS];
};

export const getFirebaseConfig = () => {
  const env = process.env.REACT_APP_ENV || 'dv';
  return FIREBASE_CONFIG[env as keyof typeof FIREBASE_CONFIG];
}
